import { useState, useEffect, useRef } from 'react'
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import api from 'helpers/api'
import moment from 'moment'
import style from './Calendar.module.scss'
import "./Calendar.global.scss"
import { useSelector } from "react-redux";
import Loader from 'components/miscellaneous/Loader/Loader'
import { minuteTimeSlot } from 'pages/Book/ClientBook/UI/DateSelection/DateSelection'

const Calendar = ({onEventClick, doRefresh, updateBooking}) => {
    const workingHours = useSelector(state => state.auth?.clinic?.working_hours)
    const [ isLoading, setIsLoading ] = useState(false);
    const [ events, setEvents ] = useState([])
    const [ businessHours, setBusinessHours ] = useState([])
    const calendarRef = useRef();


    const getAppointments = async () => {
        setIsLoading(true);
        try {
            let res = await api.get(getAPIUrl());
            if (res && res.success && res.data.success) {
                const { data, pagination } = res.data.data;
                setEvents(data.map((d) => {
                    return {
                        title: d.service ? d.service.name : 'Appointment',
                        start: d.scheduled_at,
                        end: moment(d.scheduled_at).add(minuteTimeSlot, 'minutes').format('YYYY-MM-DD HH:mm:ss'),
                        booking: d
                    }
                }));
            }
        } catch (e) {
            console.error(e)
        } finally {
            setIsLoading(false);
        }
    }

    const getBusinessHours = () => {
        return workingHours ? workingHours.map((d) => {
            return {
                daysOfWeek: [ d.day ],
                startTime: d.open ? d.open : '00:00',
                endTime: d.close ? d.close : '00:01'
            }
        }) : false;
    }

    const isDateInBusinessHours = (date) => {
        if (businessHours) {
            const day = moment(date);            
            return businessHours.some((d) => {
                const sameDayOfTheWeek = d.daysOfWeek[ 0 ] === date.getDay();
                if(sameDayOfTheWeek) {
                    const dayStart = moment(`${day.format('YYYY-MM-DD')} ${d.startTime}`).subtract(1, 'minute');
                    const dayEnd = moment(`${day.format('YYYY-MM-DD')} ${d.endTime}`).add(1, 'minute');
                    const isBetween = day.isBetween(dayStart, dayEnd);
                    return isBetween
                }
            })
        }

        return true;
    }

    const getTimeRange = () => {
        if (businessHours) {
            let minStart = null;
            let maxStart = null;

            businessHours.map((d) => {
                const start = moment(d.startTime, 'HH:mm');
                const end = moment(d.endTime, 'HH:mm');

                if (start.format('HH') !== end.format('HH') && (d.startTime !== null && d.endTime !== null)) {
                    const startInt = start.format('HH') == '00' ? 24 : parseInt(start.format('HH'));
                    const endInt = end.format('HH') == '00' ? 24 : parseInt(end.format('HH'));

                    if (minStart === null || startInt < minStart) {
                        minStart = startInt;
                    }

                    if (maxStart === null || endInt > maxStart) {
                        maxStart = endInt;
                    }
                }

            }).filter(d => d !== undefined);

            if (minStart !== null && maxStart !== null) {
                return {
                    start: `${minStart !== 24 ? minStart : '00'}:00`,
                    end: `${maxStart !== 24 ? maxStart : '00'}:00`
                }
            }
        }

        return {
            start: '00:00',
            end: '00:00'
        }
    }

    const selectAllow = (d) => {
        const allowed = isDateInBusinessHours(d.start) && isDateInBusinessHours(d.end) ? true : false;
        return allowed;
    }

    const handleDragDrop = (d) => {
        const {event} = d;
        const allowed = isDateInBusinessHours(event.start) && isDateInBusinessHours(event.end) ? true : false;

        if(!allowed) {
            d.revert();
        } else {
            const booking = event.extendedProps.booking;
            booking.scheduled_at = moment(event.start).format('YYYY-MM-DD HH:mm:ss');
            booking.scheduled_at_end = moment(event.end).format('YYYY-MM-DD HH:mm:ss');
            updateBooking(booking);
        }
    }

    const getAPIUrl = () => {
        return `/booking?page=1&per_page=200`;
    }

    const handleDateClick = (arg) => {

    }

    const handleDateSelect = (arg) => {
        // console.log('Date Select: ', arg)
    }

    const handleEventClick = (eventInfo) => {
        const booking = eventInfo.event.extendedProps.booking;
        //setEditBooking(booking);
        onEventClick(booking);
    }

    const handleEventAdd = (clickInfo) => {
        // console.log('Event Added:', clickInfo)
    }

    const handleEventChange = (clickInfo) => {
        // console.log('Event Changed:', clickInfo)
    }

    const handleEventRemove = (clickInfo) => {
    }

    const renderEventContent = (eventInfo) => {
        const booking = eventInfo.event.extendedProps.booking;
        return <div className={ style.event }>
            { booking !== undefined && booking.service !== undefined  && booking.service !== null && <img src={ booking.service.icon } width={ 32 } height={ 32 } /> }
            <div>
                <b>{ eventInfo.event.title }</b>
                <div>{ eventInfo.timeText }</div>
            </div>
        </div>
    }

    useEffect(() => {
        getAppointments();
    }, [])

    useEffect(() => {
        setBusinessHours(getBusinessHours());
    }, [ workingHours ])

    useEffect(() => {
        if(doRefresh === true) {
            getAppointments();
        }
    }, [doRefresh])
    return (
        <div style={{position: 'relative'}}>
            {isLoading && <div className={ style.loading }>
                <Loader color="#ddd" />
            </div> }
            <FullCalendar
                ref={ calendarRef }
                plugins={ [ dayGridPlugin, timeGridPlugin, interactionPlugin ] }
                initialView="timeGridWeek"
                headerToolbar={ {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                } }
                events={ events }
                editable={ true }
                selectable={ false }
                selectMirror={ true }
                dayMaxEvents={ false }
                allDaySlot={ false }
                select={ handleDateSelect }
                dateClick={ handleDateClick }
                eventClick={ handleEventClick }
                eventAdd={ handleEventAdd }
                eventChange={ handleEventChange }
                eventRemove={ handleEventRemove }
                eventContent={ renderEventContent }
                weekends={ true }
                //weekNumberCalculation={ 'local' }
                slotLabelFormat={ {
                    hour: 'numeric',
                    minute: '2-digit',
                    omitZeroMinute: false,
                    meridiem: 'short'
                } }
                contentHeight={450 }
                eventMinHeight={ 45 }
                expandRows={ true }
                businessHours={ businessHours }
                selectAllow={ selectAllow }
                eventDrop={ handleDragDrop }
                slotMinTime={ getTimeRange().start }
                slotMaxTime={ getTimeRange().end }
                slotDuration={'00:15:00'}
            />
        </div>
    )
}

export default Calendar;